import React, { useRef, useState, useEffect } from 'react';
import './Gallery.css'; // Import the stylesheet
import { Link } from 'react-router-dom';

import gallery1 from './../../assets/images/gallery/gallery1.webp';
import gallery2 from './../../assets/images/gallery/gallery2.webp';
import gallery3 from './../../assets/images/gallery/gallery3.webp';
import gallery4 from './../../assets/images/gallery/gallery4.webp';
import gallery5 from './../../assets/images/gallery/gallery5.webp';
import gallery6 from './../../assets/images/gallery/gallery6.webp';
import gallery7 from './../../assets/images/gallery/gallery7.webp';
import gallery8 from './../../assets/images/gallery/gallery8.webp';
import gallery9 from './../../assets/images/gallery/gallery9.webp';
import gallery10 from './../../assets/images/gallery/gallery10.webp';
import gallery11 from './../../assets/images/gallery/gallery11.webp';
import gallery12 from './../../assets/images/gallery/gallery12.webp';

import companyVideo from './../../assets/videos/infoVid.mp4';
import thumbnailImage from './../../assets/videos/videoThumbnail.PNG';

import { Helmet } from 'react-helmet-async';

const Gallery = () => {
    const videoRef = useRef(null);
      const [galleryImages, setGalleryImages] = useState([]);
        const [loading, setLoading] = useState(true);
        const [error, setError] = useState('');

        useEffect(() => {
            const fetchImages = async () => {
            try {
                const res = await fetch(`${process.env.REACT_APP_API_URL}/api/public/gallery/images`); // Or `/api/admin/gallery/images` if public
                if (!res.ok) throw new Error('Failed to fetch images');
                const { images } = await res.json();
                setGalleryImages(images.filter(img => img.is_active)); // Only show "active" images
            } catch (err) {
                setError('Failed to load gallery images.');
            } finally {
                setLoading(false);
            }
            };
            fetchImages();
        }, []);

        function chunkArray(arr, chunkSize) {
        const chunks = [];
        for (let i = 0; i < arr.length; i += chunkSize) {
            chunks.push(arr.slice(i, i + chunkSize));
        }
        return chunks;
        }

        const PLACEHOLDER_COUNT = 12; // Or set dynamically from DB if you want
        const placeholders = Array.from({ length: PLACEHOLDER_COUNT }, (_, i) => i);

        // Build an array of full URLs for gallery images (limit to 20 if you wish)
        let galleryImageUrls = [];
        if (!loading && !error && galleryImages.length > 0) {
        galleryImageUrls = galleryImages.slice(0, 20).map(img =>
            `${process.env.REACT_APP_API_URL}/uploads/gallery/${img.image_url}`
        );
        }

    return (
        <>
            <Helmet>
                <title>Gallery | Marion County, FL | Watkins Seamless Gutters</title>
                <meta 
                    name="description" 
                    content="Watkins Seamless Gutters provides the best in gutter service, installation and repair in Marion County, Florida and beyond. Click here to see photos of our work." 
                />

                <meta name="twitter:card" content="summary" />
                <meta name="twitter:title" content="Gallery | Marion County, FL | Watkins Seamless Gutters" />
                <meta name="twitter:description" content="Watkins Seamless Gutters provides the best in gutter service, installation and repair in Marion County, Florida and beyond. Click here to see photos of our work." />

                <meta property="og:description" content="Watkins Seamless Gutters provides the best in gutter service, installation and repair in Marion County, Florida and beyond. Click here to see photos of our work." />
                <meta property="og:title" content="Gallery | Marion County, FL | Watkins Seamless Gutters" />

                <link rel="canonical" href="https://www.watkinsgutters.com/gallery" />


                {!loading && !error && galleryImageUrls.length > 0 && (
                    <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "LocalBusiness",
                        "name": "Watkins Seamless Gutters",
                        "url": "https://www.watkinsgutters.com/gallery",
                        "telephone": "352-812-0831",
                        "email": "GuttersByWatkins@gmail.com",
                        "description": "Watkins Seamless Gutters provides seamless gutter installation and repair services in Sumter, Marion, and Lake Counties, Florida. Click here to see photos of our work.",
                        "image": galleryImageUrls,
                        "areaServed": {
                        "@type": "Place",
                        "name": [
                            "Sumter County, FL", 
                            "Marion County, FL", 
                            "Lake County, FL", 
                            "Ocala, FL", 
                            "Ocklawaha, FL",  
                            "Summerfield, FL",
                            "Leesburg, FL", 
                            "The Villages, FL"
                        ]
                        },
                        "address": {
                            "@type": "PostalAddress",
                            "addressLocality": "Marion County",
                            "addressRegion": "FL",
                            "addressCountry": "US"
                        },
                        "sameAs": [
                            "https://www.facebook.com/GuttersByWatkins"
                        ],
                        "contactPoint": {
                            "@type": "ContactPoint",
                            "telephone": "352-812-0831",
                            "contactType": "Customer Service",
                            "areaServed": [
                                "Sumter County, FL", 
                                "Marion County, FL", 
                                "Lake County, FL", 
                                "Ocala, FL", 
                                "Ocklawaha, FL",  
                                "Summerfield, FL",
                                "Leesburg, FL", 
                                "The Villages, FL"
                            ],
                            "availableLanguage": ["English"]
                        }
                    })}
                    </script>
                )}
            </Helmet>


            <div className='page-wrapper'>
                <div className='page-content-container'>
                    <div className='content-wrapper'>
                        <div className='page-content'>
                            <div className='page-content-wrapper'>
                                <div className='page-title-wrapper'>
                                    <div className='page-title'>
                                        <h1>See Photos of Our Work Here!</h1>
                                    </div>
                                    <div className='page-subtitle'>
                                        <p>
                                            Following is a small sample of the hundreds and hundreds of installations we have done over the years.
                                            <br/><br/>
                                            Frankly, one gutter install looks pretty much like another, so to save you time we have limited this gallery to a small sample. For a real idea of our capability and customer satisfaction check out the <Link to='/testimonials'>Testimonials</Link> which really address how well we performed.
                                        </p>
                                    </div>

                                    {/* Dynamic Gallery Images */}
                                    {loading ? (
                                    chunkArray(placeholders, 4).map((row, rowIdx) => (
                                        <div className='gallery-row-wrapper' key={rowIdx}>
                                        <div className='gallery-row'>
                                            {row.map((_, colIdx) => (
                                            <div className='gallery-img-wrapper' key={colIdx}>
                                                <div className='gallery-image'>
                                                <div
                                                    className="gallery-img-skeleton"
                                                    style={{
                                                    width: 555,
                                                    height: 416,
                                                    background: "#eee",
                                                    borderRadius: "6px"
                                                    }}
                                                    aria-hidden="true"
                                                />
                                                </div>
                                            </div>
                                            ))}
                                        </div>
                                        </div>
                                    ))
                                    ) : error ? (
                                    <div className="gallery-error" role="alert">{error}</div>
                                    ) : (
                                    galleryImages.length === 0 ? (
                                        <div>No gallery images to show yet.</div>
                                    ) : (
                                        chunkArray(galleryImages, 4).map((row, rowIdx) => (
                                        <div className='gallery-row-wrapper' key={rowIdx}>
                                            <div className='gallery-row'>
                                            {row.map((img) => (
                                                <div className='gallery-img-wrapper' key={img.id}>
                                                <div className='gallery-image'>
                                                    <img
                                                    src={`${process.env.REACT_APP_API_URL}/uploads/gallery/${img.image_url}`}
                                                    alt={img.alt_text}
                                                    height='416'
                                                    width='555'
                                                    loading="lazy"
                                                    style={{ background: "#eee" }}
                                                    />
                                                </div>
                                                </div>
                                            ))}
                                            </div>
                                        </div>
                                        ))
                                    )
                                    )}



                                    <div className='video-row-wrapper'>
                                        <div className='video-wrapper'>
                                            <div className='video-container'>
                                            <video
                                                src={companyVideo}
                                                controls
                                                poster={thumbnailImage}
                                                ref={videoRef}
                                                onLoadedMetadata={() => {
                                                  videoRef.current.volume = 0.15;
                                                }}
                                            ></video>
                                            </div>
                                        </div>
                                    </div>

                                    
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Gallery;